import img from "../US_img/US_ACOUSTIC.webp";
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const Feature = ({ icon, title, text }) => (
  <div className="us-feature">
    <div data-aos="fade-up" className="us-feature-icon">{icon}</div>
    <h4 data-aos="fade-up">{title}</h4>
    <p data-aos="fade-up">{text}</p>
  </div>
);

const SectionTitle = ({ small, big }) => (
  <div className="us-section-title">
    <span data-aos="fade-up">{small}</span>
    <h2 data-aos="fade-up">{big}</h2>
  </div>
);

export default function UsAcousticTechnical() {

  useEffect(() => {
      AOS.init({
        duration: 1500,
        once: true,
      });
    }, []);

  return (
    <div className="us-page">

      {/* HERO */}
      <section className="us-hero">
        <div className="us-hero-content">
          <div data-aos="fade-right" className="us-badge">
            <h3>
              <span className="subtitle-us">US</span> <b>ACOUSTIC</b>
            </h3>
          </div>

          <h1 data-aos="fade-up">Avec des propriétés techniques</h1>

          <p data-aos="fade-up">
            Solutions acoustiques architecturales conçues pour améliorer
            significativement le confort sonore des espaces professionnels
            et publics.
          </p>

          <div data-aos="zoom-in" className="us-hero-buttons">
            <a className="btn-primarya" href="/devis">
              Demander un devis
            </a>
            <a
              href="/docs/fiche-technique-us-acoustic.pdf"
              download
              className="btn-outline"
            >
              Télécharger la fiche technique
            </a>
          </div>
        </div>

        <div data-aos="fade-up" className="us-hero-image">
          <img src={img} alt="US Acoustic solutions techniques" />
        </div>
      </section>

      {/* DESCRIPTION */}
      <section className="us-section">
        <SectionTitle
          small="Présentation"
          big="Qu’est-ce que la solution US ACOUSTIC ?"
        />

        <div className="us-two-cols">
          <p data-aos="fade-up">
            US ACOUSTIC propose une large gamme de textiles acoustiques
            développés spécialement pour l’architecture. Les textiles sont
            en polyester tissé ou tricoté, disponibles en très grandes largeurs
            (plus de 5 m).
          </p>

          <p data-aos="fade-up">
            Ces solutions sont associées à des molletons acoustiques ou à
            des panneaux de laine minérale de 10 à 40 mm afin d’obtenir
            de très hautes performances d’absorption sonore.
          </p>
        </div>
      </section>

      {/* AVANTAGES */}
      <section className="us-section us-gray">
        <SectionTitle small="Atouts" big="Avantages clés" />

        <div className="us-grid">
          <Feature
            icon="🔊"
            title="Haute absorption acoustique"
            text="Réduction efficace de la réverbération et amélioration du confort sonore."
          />
          <Feature
            icon="⚡"
            title="Mise en œuvre rapide"
            text="Installation propre et rapide sans travaux lourds."
          />
          <Feature
            icon="📐"
            title="Très grandes largeurs"
            text="Textiles disponibles en largeurs supérieures à 5 mètres."
          />
          <Feature
            icon="🌱"
            title="Démarche écologique"
            text="Solutions respectueuses de l’environnement – démarche HQE."
          />
          <Feature
            icon="🏗️"
            title="Usage architectural"
            text="Adapté aux projets professionnels et architecturaux exigeants."
          />
          <Feature
            icon="🛠️"
            title="Durabilité"
            text="Matériaux résistants et performances acoustiques durables."
          />
        </div>
      </section>

      {/* TECHNIQUE */}
      <section className="us-section">
        <SectionTitle small="Technique" big="Caractéristiques techniques" />

        <ul data-aos="fade-up" className="us-list">
          <li>Textiles acoustiques en polyester tissé ou tricoté</li>
          <li>Largeurs disponibles : jusqu’à plus de 5 m</li>
          <li>Molletons acoustiques ou laine minérale (10 à 40 mm)</li>
          <li>Très hautes performances d’absorption acoustique</li>
          <li>Correction efficace des échos et de la réverbération</li>
          <li>Compatible avec intégration architecturale moderne</li>
        </ul>
      </section>

      {/* APPLICATIONS */}
      <section className="us-section us-gray">
        <SectionTitle small="Applications" big="Domaines d’utilisation" />

        <div className="us-tags" data-aos="fade-up">
          {[
            "Bureaux",
            "Open spaces",
            "Salles de réunion",
            "Restaurants",
            "Hôtels",
            "Espaces culturels",
            "Établissements scolaires",
            "Espaces publics",
          ].map((item) => (
            <span key={item}>{item}</span>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="us-cta">
        <h2>Besoin d’une solution acoustique performante ?</h2>
        <p>Nos équipes vous accompagnent dans vos projets acoustiques.</p><br/>
        <a href="/contact" className="btn-primarya">Contactez-nous</a>
      </section>

    </div>
  );
}
